import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const AgreementsListLine = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C10.1362 1 8.57006 2.27477 8.12602 4H7C5.34315 4 4 5.34315 4 7V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V7C20 5.34315 18.6569 4 17 4H15.874C15.4299 2.27477 13.8638 1 12 1ZM7 6H8.12602C8.57006 7.72523 10.1362 9 12 9C13.8638 9 15.4299 7.72523 15.874 6H17C17.5523 6 18 6.44772 18 7V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V7C6 6.44772 6.44772 6 7 6ZM12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7ZM11.042 15.044L14.403 11.2968H14.3941C14.6937 10.9657 15.255 10.902 15.6478 11.1544C16.0407 11.4069 16.1163 11.88 15.8168 12.2111L11.7533 16.7077C11.5854 16.8915 11.3261 16.9994 11.0509 17C10.7772 17.0012 10.5181 16.8962 10.3484 16.7152L8.1878 14.3845C7.88579 14.0575 7.95546 13.5861 8.3434 13.3315C8.73134 13.077 9.29066 13.1357 9.59266 13.4627L11.042 15.044Z",
    fill: "currentColor"
  })
});